/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const CheckIcon = props => {
	const { color = '' } = props
	return (
		<svg
			data-testid='check-icon'
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			viewBox='0 -2 6 8'
		>
			<path
				data-name='Trazado 43702'
				d='M1.99 3.828a.459.459 0 0 1-.325-.134L.134 2.162a.46.46 0 0 1 .65-.65L1.99 2.719 4.575.134a.46.46 0 0 1 .65.65l-2.91 2.909a.459.459 0 0 1-.325.135Z'
				fill={color}
			/>
		</svg>
	)
}

export default CheckIcon
